import { FC } from 'react';
import clsx from 'clsx';

import { IDateCardProps } from '../models/types';

import styles from './styles.module.scss';

export const DateCard: FC<IDateCardProps> = ({ isScrolledDown, data }) => {
  return (
    <div
      className={clsx(
        {
          [styles['date-card']]: !isScrolledDown,
        },
        {
          [styles['date-card_scrolled']]: isScrolledDown,
        },
        {
          [styles['date-card__primary']]: data.isPrimary && !isScrolledDown,
        },
        {
          [styles['date-card_scrolled__primary']]:
            data.isPrimary && isScrolledDown,
        },
      )}
    >
      <div
        className={clsx(
          {
            [styles['date-card__section-1']]: !isScrolledDown,
          },
          {
            [styles['date-card_scrolled__section-1']]: isScrolledDown,
          },
        )}
      >
        <span
          className={clsx(
            {
              [styles['date-card__date']]: !isScrolledDown,
            },
            {
              [styles['date-card_scrolled__date']]: isScrolledDown,
            },
            {
              [styles['date-card_scrolled__date_primary']]:
                isScrolledDown && data.isPrimary,
            },
          )}
        >
          {/* 12 марта, Ср */}
          {data.date}
        </span>
        <span
          className={clsx(
            {
              [styles['date-card__lesson-quantity']]: !isScrolledDown,
            },
            {
              [styles['date-card_scrolled__lesson-quantity']]: isScrolledDown,
            },
            {
              [styles['date-card_scrolled__lesson-quantity_primary']]:
                isScrolledDown && data.isPrimary,
            },
          )}
        >
          {' '}
          — {data.lessonQuantity}
        </span>
      </div>
      <div
        className={clsx(
          {
            [styles['date-card__section-2']]: !isScrolledDown,
          },
          {
            [styles['date-card_scrolled__section-2']]: isScrolledDown,
          },
        )}
      >
        {!isScrolledDown && (
          <span className={styles['date-card__time-interval']}>
            {/* 08:00 — 15:00 */}
            {data.timeInterval}
          </span>
        )}
        {!isScrolledDown && data.timeInterval.length !== 0 && (
          <div className={styles['date-card__section-2-delimiter']}></div>
        )}
        <span
          className={clsx(
            {
              [styles['date-card__week-parity']]: !isScrolledDown,
            },
            {
              [styles['date-card_scrolled__week-parity']]: isScrolledDown,
            },
            {
              [styles['date-card_scrolled__week-parity_primary']]:
                isScrolledDown && data.isPrimary,
            },
          )}
        >
          {/* нечетная неделя */}
          {data.weekParity}
        </span>
      </div>
    </div>
  );
};
